export const registerNavBar = (displayName) => [
  {
    text: displayName || "Registration Form",
    icon: "mdi-email",
    to: "/register-form",
  },
];